import React, { Component } from 'react';
import Highcharts from 'react-highcharts';
import chartsConfig from '../../../common/chartsConfig';
import './style.less';

const DefaultLegend = {
    align: 'right',
    verticalAlign: 'top',
    x: 0,
    y: 20,
    layout: 'vertical',
    width: 100,
};

class Charts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            legendEnable: true,
        };
    }

    getExporting = () => {
        const { filename } = this.props;
        return {
            enabled: true,
            filename,
            buttons: {
                contextButton: {
                    align: "right",
                    x: -10,
                    y: -10,
                    menuItems: [
                        'downloadJPEG',
                        'downloadPDF',
                        'downloadPNG',
                        'downloadSVG',
                        {
                            onclick: this.props.onClick,
                            text: '导出Excel'
                        }
                    ]
                }
            },
            chartOptions: {
                legend: {
                    x: -24,
                    width: false,
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                }
            },
            allowHTML: true,
            sourceWidth: 1000,
			sourceHeight: 500,
        };
    }

    getChartsConfig() {
        const { legendEnable } = this.state;
        const { title = {
            text: null
        }, type = null, xAxis = {}, yAxis = {}, tooltip = {}, plotOptions = {}, series, legend: propLegend } = this.props;
        const legend = Object.assign({ enabled: legendEnable }, DefaultLegend, propLegend);
        return {
            chart: {
                type,
                zoomType: 'xy',
                marginTop: 30,
                height: this.computeHeight(),
            },
            title,
            xAxis,
            yAxis,
            tooltip,
            plotOptions,
            legend,
            series,
            exporting: this.getExporting(),
            credits: {
                enabled: false,
            },
        };
    }

    handleLegendStatus = () => {
        this.setState(state => ({ legendEnable: !state.legendEnable }));
    }

    computeHeight = () => {
        const { height } = this.props;
        return height < 450 ? 320: height;
    }

    render() {
        const { isPie, negativeMoney } = this.props;
        const { legendEnable } = this.state;
        return (
            <div className="chart" style={{ height: this.computeHeight() }}>
                <div className="position">
                    <span className="legend" onClick={this.handleLegendStatus}>{legendEnable ? '隐藏' : '显示'}图例</span>
                    { !isPie && <span className="unit">（ M：百万；K：千 ）</span> }
                    { negativeMoney && negativeMoney }
                </div>
                <Highcharts config={{ ...chartsConfig, ...this.getChartsConfig() }} />
            </div>
        );
    }
}

export default Charts;



// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/components/Charts/index.js